module.exports = __webpack_public_path__ + "static/media/dropoffTimelineIcon.5b6c88aa.svg";